import type { User } from '#auth-utils'

export type Contact = Nullable<{
  email: string
  phone: string
}>

function load(model?: Partial<Contact> | null, user?: User | null): Contact {
  return {
    email: model?.email ?? user?.email ?? null,
    phone: model?.phone ?? user?.userData?.mobile ?? null,
  }
}

export const Contact = {
  load,
}
